import { Module } from "wrapper6";
import { InlineCookieInput } from "../utils/_inline_cookie_input";
import { getPersonalPriceEventGroup } from "../utils/_personal-price";

var $ = jQuery;

export default class EventInfobox extends Module {
    ready(app) {
        if(jQuery('.mtt-course-cover .course-cover-inner').length > 0) this.setMinHeight();
    }

    setMinHeight(){
        let cover = jQuery('.mtt-course-cover .course-cover-inner');
        let infobox = cover.find('.course-information');
        let min_height = infobox.outerHeight() + 50; // height of infobox + margin for shadow etc
        cover.css('minHeight',min_height + 'px');
    }
}